import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "title mb-0" }
const _hoisted_7 = { class: "breadcrumb-wrap mt-1" }
const _hoisted_8 = { "aria-label": "breadcrumb" }
const _hoisted_9 = { class: "breadcrumb mb-0" }
const _hoisted_10 = { class: "breadcrumb-item" }
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "fa fa-home" }, null, -1)
const _hoisted_12 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_13 = {
  href: "javascript:void(0)",
  class: "breadcrumb-item active"
}
const _hoisted_14 = { class: "col-md-12" }
const _hoisted_15 = { class: "text-md-right" }
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-left" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_18 = { class: "card" }
const _hoisted_19 = { class: "row align-items-center" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "title mb-0" }
const _hoisted_22 = { class: "table-responsive my-3 font-12" }
const _hoisted_23 = { class: "table table-bordered table-shadowed mb-0" }
const _hoisted_24 = { class: "table-primary nowrap-text" }
const _hoisted_25 = { scope: "col" }
const _hoisted_26 = { scope: "col" }
const _hoisted_27 = { scope: "col" }
const _hoisted_28 = { scope: "col" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 0,
  class: "badge badge-primary"
}
const _hoisted_31 = {
  key: 1,
  class: "badge badge-warning"
}
const _hoisted_32 = {
  key: 2,
  class: "badge badge-success"
}
const _hoisted_33 = {
  key: 3,
  class: "badge badge-danger"
}
const _hoisted_34 = {
  key: 4,
  class: "badge badge-info"
}
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "text-nowrap" }
const _hoisted_38 = /*#__PURE__*/_createVNode("i", { class: "fa fa-paper-plane" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye" }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { colspan: "5" }
const _hoisted_47 = { class: "modal-wrap default-modal" }
const _hoisted_48 = {
  class: "modal fade",
  id: "deleteJobEstimation",
  "aria-labelledby": "view-modalLabel",
  "aria-hidden": "true"
}
const _hoisted_49 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_50 = { class: "modal-content" }
const _hoisted_51 = { class: "modal-header" }
const _hoisted_52 = {
  class: "modal-title",
  id: "view-modalLabel"
}
const _hoisted_53 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_54 = { class: "modal-body" }
const _hoisted_55 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_56 = { class: "text-danger" }
const _hoisted_57 = { class: "modal-footer" }
const _hoisted_58 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_59 = {
  class: "modal fade",
  id: "showDetailsAdmin",
  tabindex: -1,
  "aria-labelledby": "previewModalLabel",
  "aria-hidden": "true"
}
const _hoisted_60 = { class: "modal-dialog" }
const _hoisted_61 = { class: "modal-content" }
const _hoisted_62 = { class: "modal-header" }
const _hoisted_63 = /*#__PURE__*/_createVNode("i", { class: "fa fa-print" }, null, -1)
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" Print")
const _hoisted_65 = /*#__PURE__*/_createVNode("i", { class: "fa fa-download" }, null, -1)
const _hoisted_66 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close",
  click: "detailsClose",
  title: "close"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_67 = { class: "modal-body bg-light" }
const _hoisted_68 = { class: "invoice-holder shadowed-box rounded p-3 bg-white" }
const _hoisted_69 = { class: "d-flex" }
const _hoisted_70 = { class: "flex-grow-1" }
const _hoisted_71 = { class: "invoice-logo" }
const _hoisted_72 = { class: "invoice-address" }
const _hoisted_73 = { class: "uppercase-text" }
const _hoisted_74 = { class: "flex-shrink-0 mt-sm-0 mt-3" }
const _hoisted_75 = { class: "text-muted" }
const _hoisted_76 = { class: "text-muted" }
const _hoisted_77 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_78 = { class: "row" }
const _hoisted_79 = { class: "col-md-3" }
const _hoisted_80 = { class: "text-muted uppercase-text" }
const _hoisted_81 = { class: "col-md-3" }
const _hoisted_82 = { class: "text-muted uppercase-text" }
const _hoisted_83 = { class: "col-md-3" }
const _hoisted_84 = { class: "text-muted uppercase-text" }
const _hoisted_85 = { key: 0 }
const _hoisted_86 = { key: 1 }
const _hoisted_87 = { class: "mt-4" }
const _hoisted_88 = { key: 0 }
const _hoisted_89 = { class: "row" }
const _hoisted_90 = { class: "mt-3 border p-2" }
const _hoisted_91 = { key: 0 }
const _hoisted_92 = { class: "to-upper" }
const _hoisted_93 = { key: 1 }
const _hoisted_94 = { key: 2 }
const _hoisted_95 = { class: "table-responsive mt-4 font-12" }
const _hoisted_96 = { class: "table mb-0 table-borderless" }
const _hoisted_97 = { class: "nowrap-text" }
const _hoisted_98 = { class: "table-active" }
const _hoisted_99 = {
  scope: "col",
  class: "to-upper"
}
const _hoisted_100 = { scope: "col" }
const _hoisted_101 = { scope: "col" }
const _hoisted_102 = { scope: "col" }
const _hoisted_103 = {
  scope: "col",
  class: "to-upper"
}
const _hoisted_104 = { scope: "col" }
const _hoisted_105 = { scope: "col" }
const _hoisted_106 = { scope: "col" }
const _hoisted_107 = {
  scope: "col",
  class: "text-end to-upper"
}
const _hoisted_108 = {
  colspan: "8",
  class: "pb-0"
}
const _hoisted_109 = { class: "mb-0" }
const _hoisted_110 = { class: "ps-3" }
const _hoisted_111 = { class: "desc-wrap" }
const _hoisted_112 = { key: 0 }
const _hoisted_113 = { key: 1 }
const _hoisted_114 = { class: "text-end" }
const _hoisted_115 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_116 = { class: "row justify-content-end" }
const _hoisted_117 = { class: "col-lg-3 col-md-9" }
const _hoisted_118 = { class: "total-box" }
const _hoisted_119 = { class: "table table-borderless table-nowrap align-middle mb-0 ms-auto" }
const _hoisted_120 = { scope: "row" }
const _hoisted_121 = { class: "text-end" }
const _hoisted_122 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_123 = {
  key: 0,
  class: "alert alert-danger mt-3"
}
const _hoisted_124 = { class: "mb-0" }
const _hoisted_125 = { class: "uppercase-text" }
const _hoisted_126 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_127 = {
  key: 0,
  class: "bg-light rounded p-3 border mt-3"
}
const _hoisted_128 = { class: "tab-wrap bg-white rounded px-3 pb-3 border" }
const _hoisted_129 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_130 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_131 = {
  class: "nav-link active",
  id: "Contract-tab",
  "data-toggle": "tab",
  "data-target": "#Contract",
  type: "button",
  role: "tab",
  "aria-controls": "Contract",
  "aria-selected": "true"
}
const _hoisted_132 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_133 = {
  class: "nav-link",
  id: "Contract1-tab",
  "data-toggle": "tab",
  "data-target": "#Contract1",
  type: "button",
  role: "tab",
  "aria-controls": "Contract1",
  "aria-selected": "false"
}
const _hoisted_134 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_135 = {
  class: "tab-pane fade show active",
  id: "Contract",
  role: "tabpanel",
  "aria-labelledby": "Contract-tab"
}
const _hoisted_136 = {
  class: "tab-pane fade",
  id: "Contract1",
  role: "tabpanel",
  "aria-labelledby": "Contract1-tab"
}
const _hoisted_137 = {
  key: 1,
  class: "alert alert-info mt-3"
}
const _hoisted_138 = { class: "mb-0" }
const _hoisted_139 = {
  key: 2,
  class: "card d-block mt-3"
}
const _hoisted_140 = { class: "card-head pb-3" }
const _hoisted_141 = { class: "card-title" }
const _hoisted_142 = { class: "row" }
const _hoisted_143 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_144 = { class: "signature-wrap my-2" }
const _hoisted_145 = { class: "signature-wrap my-2" }
const _hoisted_146 = { class: "to-upper" }
const _hoisted_147 = { class: "modal-footer" }
const _hoisted_148 = /*#__PURE__*/_createVNode("i", { class: "fa fa-print" }, null, -1)
const _hoisted_149 = /*#__PURE__*/_createVNode("i", { class: "fa fa-download" }, null, -1)
const _hoisted_150 = {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}
const _hoisted_151 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_152 = {
  class: "modal fade",
  id: "showDetails",
  tabindex: -1,
  "aria-labelledby": "previewModalLabel",
  "aria-hidden": "true"
}
const _hoisted_153 = { class: "modal-dialog" }
const _hoisted_154 = { class: "modal-content" }
const _hoisted_155 = { class: "modal-header" }
const _hoisted_156 = /*#__PURE__*/_createVNode("i", { class: "fa fa-print" }, null, -1)
const _hoisted_157 = /*#__PURE__*/_createTextVNode(" Print")
const _hoisted_158 = /*#__PURE__*/_createVNode("i", { class: "fa fa-download" }, null, -1)
const _hoisted_159 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close",
  click: "detailsClose"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_160 = { class: "modal-body bg-light" }
const _hoisted_161 = { class: "invoice-holder shadowed-box rounded p-3 bg-white" }
const _hoisted_162 = { class: "d-flex" }
const _hoisted_163 = { class: "flex-grow-1" }
const _hoisted_164 = { class: "invoice-logo" }
const _hoisted_165 = { class: "invoice-address" }
const _hoisted_166 = { class: "uppercase-text" }
const _hoisted_167 = { class: "flex-shrink-0 mt-sm-0 mt-3" }
const _hoisted_168 = { class: "text-muted" }
const _hoisted_169 = { class: "text-muted" }
const _hoisted_170 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_171 = { class: "row" }
const _hoisted_172 = { class: "col-md-3" }
const _hoisted_173 = { class: "text-muted text-capitalize uppercase-text" }
const _hoisted_174 = { class: "col-md-3" }
const _hoisted_175 = { class: "text-muted text-capitalize uppercase-text" }
const _hoisted_176 = { class: "col-md-3" }
const _hoisted_177 = { class: "text-muted text-capitalize uppercase-text" }
const _hoisted_178 = { key: 0 }
const _hoisted_179 = { key: 1 }
const _hoisted_180 = { class: "mt-4" }
const _hoisted_181 = { key: 0 }
const _hoisted_182 = { class: "row" }
const _hoisted_183 = { class: "mt-3 border p-2" }
const _hoisted_184 = { key: 0 }
const _hoisted_185 = { key: 1 }
const _hoisted_186 = { key: 2 }
const _hoisted_187 = { class: "table-responsive mt-4 font-12" }
const _hoisted_188 = {
  key: 0,
  class: "table mb-0 table-borderless"
}
const _hoisted_189 = { class: "nowrap-text" }
const _hoisted_190 = { class: "table-active" }
const _hoisted_191 = {
  scope: "col",
  class: "to-upper"
}
const _hoisted_192 = { scope: "col" }
const _hoisted_193 = { scope: "col" }
const _hoisted_194 = { scope: "col" }
const _hoisted_195 = {
  scope: "col",
  class: "to-upper"
}
const _hoisted_196 = { scope: "col" }
const _hoisted_197 = { scope: "col" }
const _hoisted_198 = {
  scope: "col",
  class: "text-end to-upper"
}
const _hoisted_199 = {
  colspan: "8",
  class: "pb-0"
}
const _hoisted_200 = { class: "mb-0" }
const _hoisted_201 = { class: "ps-3" }
const _hoisted_202 = { class: "desc-wrap" }
const _hoisted_203 = { key: 0 }
const _hoisted_204 = { key: 1 }
const _hoisted_205 = { class: "text-end" }
const _hoisted_206 = {
  key: 1,
  class: "table mb-0 table-borderless"
}
const _hoisted_207 = { class: "nowrap-text" }
const _hoisted_208 = { class: "table-active" }
const _hoisted_209 = { scope: "col" }
const _hoisted_210 = {
  key: 0,
  scope: "col"
}
const _hoisted_211 = {
  key: 1,
  scope: "col"
}
const _hoisted_212 = {
  key: 2,
  scope: "col"
}
const _hoisted_213 = {
  key: 3,
  scope: "col"
}
const _hoisted_214 = {
  key: 4,
  scope: "col"
}
const _hoisted_215 = {
  key: 5,
  scope: "col"
}
const _hoisted_216 = {
  key: 6,
  scope: "col"
}
const _hoisted_217 = {
  key: 7,
  scope: "col",
  class: "to-upper"
}
const _hoisted_218 = {
  colspan: "8",
  class: "pb-0"
}
const _hoisted_219 = { class: "mb-0" }
const _hoisted_220 = { class: "ps-3" }
const _hoisted_221 = { key: 0 }
const _hoisted_222 = { class: "desc-wrap" }
const _hoisted_223 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_224 = { key: 2 }
const _hoisted_225 = {
  key: 3,
  class: "text-nowrap"
}
const _hoisted_226 = {
  key: 4,
  class: "text-nowrap"
}
const _hoisted_227 = {
  key: 5,
  class: "text-nowrap"
}
const _hoisted_228 = { key: 0 }
const _hoisted_229 = { key: 1 }
const _hoisted_230 = {
  key: 6,
  class: "text-nowrap"
}
const _hoisted_231 = {
  key: 7,
  class: "text-end"
}
const _hoisted_232 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_233 = { class: "row justify-content-end" }
const _hoisted_234 = { class: "col-lg-3 col-md-9" }
const _hoisted_235 = { class: "total-box" }
const _hoisted_236 = { class: "table table-borderless table-nowrap align-middle mb-0 ms-auto" }
const _hoisted_237 = { scope: "row" }
const _hoisted_238 = { class: "text-end" }
const _hoisted_239 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_240 = {
  key: 0,
  class: "alert alert-danger mt-3"
}
const _hoisted_241 = { class: "mb-0" }
const _hoisted_242 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_243 = {
  key: 2,
  class: "bg-light rounded p-3 border mt-3"
}
const _hoisted_244 = { class: "tab-wrap bg-white rounded px-3 pb-3 border" }
const _hoisted_245 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_246 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_247 = { class: "alert alert-info mt-3" }
const _hoisted_248 = { class: "mb-0" }
const _hoisted_249 = { class: "card d-block mt-3" }
const _hoisted_250 = { class: "card-head pb-3" }
const _hoisted_251 = { class: "card-title" }
const _hoisted_252 = { class: "row" }
const _hoisted_253 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_254 = { class: "signature-wrap my-2" }
const _hoisted_255 = { class: "signature-wrap my-2" }
const _hoisted_256 = { class: "to-upper" }
const _hoisted_257 = { class: "modal-footer" }
const _hoisted_258 = /*#__PURE__*/_createVNode("i", { class: "fa fa-print" }, null, -1)
const _hoisted_259 = /*#__PURE__*/_createVNode("i", { class: "fa fa-download" }, null, -1)
const _hoisted_260 = {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_EmptyData = _resolveComponent("EmptyData")
  const _component_UpgradeSubscriptionModal = _resolveComponent("UpgradeSubscriptionModal")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.state.ui.isLoading.geJobEstimationList && !_ctx.state.ui.isLoading.pusherUpdate)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("h1", _hoisted_6, _toDisplayString(_ctx.$t('list_job_estimation')), 1),
          _createVNode("div", _hoisted_7, [
            _createVNode("nav", _hoisted_8, [
              _createVNode("ol", _hoisted_9, [
                _createVNode("li", _hoisted_10, [
                  _createVNode(_component_router_link, { to: { name: 'admin-dashboard' } }, {
                    default: _withCtx(() => [
                      _hoisted_11,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('home')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("li", _hoisted_12, [
                  _createVNode("a", _hoisted_13, _toDisplayString(_ctx.$t('create_job_estimation')), 1)
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode("div", _hoisted_15, [
            _createVNode("a", {
              href: "javascript:void(0)",
              class: "btn default-btn outline d-inline-block me-2",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToProject && _ctx.redirectToProject(...args)))
            }, [
              _hoisted_16,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
            ]),
            (_ctx.state.data.role.code === 'owner' || _ctx.state.data.role.code === 'co-owner')
              ? (_openBlock(), _createBlock("a", {
                  key: 0,
                  href: "javascript:void(0)",
                  class: "btn default-btn d-inline-block",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.gotoCreateJobEstimation && _ctx.gotoCreateJobEstimation(...args)))
                }, [
                  _hoisted_17,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('create')), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_18, [
      _createVNode("div", _hoisted_19, [
        _createVNode("div", _hoisted_20, [
          _createVNode("h4", _hoisted_21, _toDisplayString(_ctx.$t('estimate')), 1)
        ])
      ]),
      _createVNode("div", _hoisted_22, [
        _createVNode("table", _hoisted_23, [
          _createVNode("thead", _hoisted_24, [
            _createVNode("tr", null, [
              _createVNode("th", _hoisted_25, _toDisplayString(_ctx.$t('estimation_no')), 1),
              _createVNode("th", _hoisted_26, _toDisplayString(_ctx.$t('status')), 1),
              _createVNode("th", _hoisted_27, _toDisplayString(_ctx.$t('date')), 1),
              _createVNode("th", _hoisted_28, _toDisplayString(_ctx.$t('action')), 1)
            ])
          ]),
          (_ctx.state.data.jobEstimationLists.length > 0)
            ? (_openBlock(), _createBlock("tbody", _hoisted_29, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.jobEstimationLists, (estimation, estimationIndex) => {
                  return (_openBlock(), _createBlock("tr", { key: estimationIndex }, [
                    _createVNode("td", null, [
                      _createVNode("p", null, "# " + _toDisplayString(estimation.no) + " " + _toDisplayString(estimation.title), 1)
                    ]),
                    _createVNode("td", null, [
                      (estimation.status == 0)
                        ? (_openBlock(), _createBlock("span", _hoisted_30, _toDisplayString(_ctx.$t('draft')), 1))
                        : _createCommentVNode("", true),
                      (estimation.status == 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_31, _toDisplayString(_ctx.$t('sent')), 1))
                        : _createCommentVNode("", true),
                      (estimation.status == 2)
                        ? (_openBlock(), _createBlock("span", _hoisted_32, _toDisplayString(_ctx.$t('approved')), 1))
                        : _createCommentVNode("", true),
                      (estimation.status == 3)
                        ? (_openBlock(), _createBlock("span", _hoisted_33, _toDisplayString(_ctx.$t('declined')), 1))
                        : _createCommentVNode("", true),
                      (estimation.status == 4)
                        ? (_openBlock(), _createBlock("span", _hoisted_34, _toDisplayString(_ctx.$t('smart_contract_created')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("td", null, [
                      (estimation.modifiedCreatedDate)
                        ? (_openBlock(), _createBlock("p", _hoisted_35, _toDisplayString(estimation.modifiedCreatedDate), 1))
                        : (_openBlock(), _createBlock("p", _hoisted_36, _toDisplayString(estimation.created_date), 1))
                    ]),
                    _createVNode("td", _hoisted_37, [
                      ((estimation.status == 0 && _ctx.state.data.role.code === 'owner' || _ctx.state.data.role.code === 'co-owner') || (estimation.status == 3 && _ctx.state.data.role.code === 'owner' || _ctx.state.data.role.code === 'co-owner'))
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            href: "javascript:void(0)",
                            class: "btn btn-sm text-primary mr-1",
                            onClick: ($event: any) => (_ctx.gotoJobEstimationSend(estimation.uuid)),
                            title: "send"
                          }, [
                            _hoisted_38,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('send')), 1)
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      ((estimation.status == 1 && _ctx.state.data.role.code === 'owner' || _ctx.state.data.role.code === 'co-owner'))
                        ? (_openBlock(), _createBlock("a", {
                            key: 1,
                            href: "javascript:void(0)",
                            class: "btn btn-sm text-primary mr-1",
                            onClick: ($event: any) => (_ctx.updateJobEstimation(estimation.uuid)),
                            title: "edit"
                          }, [
                            _hoisted_39,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      ((estimation.status == 0 && _ctx.state.data.role.code === 'owner' || _ctx.state.data.role.code === 'co-owner') || (estimation.status == 3 && _ctx.state.data.role.code === 'owner' || _ctx.state.data.role.code === 'co-owner'))
                        ? (_openBlock(), _createBlock("a", {
                            key: 2,
                            href: "javascript:void(0)",
                            class: "btn btn-sm text-primary mr-1",
                            onClick: ($event: any) => (_ctx.editJobEstimation(estimation.uuid)),
                            title: "edit"
                          }, [
                            _hoisted_40,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.state.data.role.code === 'owner' || _ctx.state.data.role.code === 'co-owner')
                        ? (_openBlock(), _createBlock("a", {
                            key: 3,
                            href: "javascript:void(0)",
                            class: "btn btn-sm text-primary mr-1",
                            onClick: ($event: any) => (_ctx.detailsShowAdmin(estimation)),
                            title: "admin details"
                          }, [
                            _hoisted_41,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('admin_details')), 1)
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (((estimation.same == 0 && estimation.status != 0 && (_ctx.state.data.role.code === 'owner' || _ctx.state.data.role.code === 'co-owner')) || (estimation.status != 0 && _ctx.state.data.role.code === 'todo_payer' || _ctx.state.data.role.code === 'estimation_member')))
                        ? (_openBlock(), _createBlock("a", {
                            key: 4,
                            href: "javascript:void(0)",
                            class: "btn btn-sm text-primary mr-1",
                            onClick: ($event: any) => (_ctx.detailsShow(estimation)),
                            title: "send details"
                          }, [
                            _hoisted_42,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('send_details')), 1)
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      ((estimation.status == 0 && _ctx.state.data.role.code === 'owner' || _ctx.state.data.role.code === 'co-owner') || (estimation.status == 3 && _ctx.state.data.role.code === 'owner' || _ctx.state.data.role.code === 'co-owner'))
                        ? (_openBlock(), _createBlock("a", {
                            key: 5,
                            href: "javascript:void(0)",
                            class: "btn btn-sm text-danger",
                            onClick: ($event: any) => (_ctx.deleteJobEstimationShow(estimationIndex, estimation)),
                            title: "delete"
                          }, [
                            _hoisted_43,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (estimation.status == 2 && (_ctx.state.data.role.code === 'owner' || _ctx.state.data.role.code === 'co-owner'))
                        ? (_openBlock(), _createBlock("a", {
                            key: 6,
                            href: "javascript:void(0)",
                            class: "btn btn-sm text-primary mr-1",
                            title: "create smart contract",
                            onClick: ($event: any) => (_ctx.sendSmartContract(estimation.uuid))
                          }, [
                            _hoisted_44,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('create_contract')), 1)
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createBlock("tfoot", _hoisted_45, [
                _createVNode("tr", null, [
                  _createVNode("td", _hoisted_46, [
                    _createVNode(_component_EmptyData, {
                      title: _ctx.state.data.title,
                      heading: _ctx.state.data.headings
                    }, null, 8, ["title", "heading"])
                  ])
                ])
              ]))
        ])
      ])
    ]),
    _createVNode("div", _hoisted_47, [
      _createVNode("div", _hoisted_48, [
        _createVNode("div", _hoisted_49, [
          _createVNode("div", _hoisted_50, [
            _createVNode("div", _hoisted_51, [
              _createVNode("h5", _hoisted_52, _toDisplayString(_ctx.$t('delete_estimation')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteJobEstimationClose()))
              }, [
                _hoisted_53
              ])
            ]),
            _createVNode("div", _hoisted_54, [
              _hoisted_55,
              _createVNode("span", _hoisted_56, _toDisplayString(_ctx.$t('are_you_sure')), 1)
            ]),
            _createVNode("div", _hoisted_57, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteJobEstimationClose()))
              }, _toDisplayString(_ctx.$t('no')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-danger",
                "data-dismiss": "modal",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteJobEstimation()))
              }, _toDisplayString(_ctx.$t('yes')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_58, [
      _createVNode("div", _hoisted_59, [
        _createVNode("div", _hoisted_60, [
          _createVNode("div", _hoisted_61, [
            _createVNode("div", _hoisted_62, [
              (_ctx.state.data.details.pdf_link)
                ? (_openBlock(), _createBlock("a", {
                    key: 0,
                    href: "javascript:void(0)",
                    class: "btn default-btn mr-2",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.downoadPdf(_ctx.state.data.details.pdf_link)))
                  }, [
                    _hoisted_63,
                    _hoisted_64
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.data.details.pdf_link)
                ? (_openBlock(), _createBlock("a", {
                    key: 1,
                    href: "javascript:void(0)",
                    class: "btn default-btn outline to-upper",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.downoadPdf(_ctx.state.data.details.pdf_link)))
                  }, [
                    _hoisted_65,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('download')), 1)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_66
            ]),
            _createVNode("div", _hoisted_67, [
              _createVNode("div", _hoisted_68, [
                _createVNode("div", _hoisted_69, [
                  _createVNode("div", _hoisted_70, [
                    _createVNode("div", _hoisted_71, [
                      (_ctx.state.data.details.logo || _ctx.state.data.companyInfo.logo)
                        ? (_openBlock(), _createBlock("img", {
                            key: 0,
                            src: _ctx.state.data.details.logo ? _ctx.state.data.details.logo : _ctx.state.data.companyInfo.logo,
                            alt: ""
                          }, null, 8, ["src"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_72, [
                      _createVNode("p", _hoisted_73, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('address')), 1)
                      ]),
                      _createVNode("p", null, _toDisplayString(_ctx.state.data.companyInfo.company_address), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_74, [
                    _createVNode("p", null, [
                      _createVNode("span", _hoisted_75, _toDisplayString(_ctx.$t('email')) + ":", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.state.data.companyInfo.company_email), 1)
                    ]),
                    _createVNode("p", null, [
                      _createVNode("span", _hoisted_76, _toDisplayString(_ctx.$t('contact_no')) + ":", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.state.data.companyInfo.company_phone_number), 1)
                    ])
                  ])
                ]),
                _hoisted_77,
                _createVNode("div", _hoisted_78, [
                  _createVNode("div", _hoisted_79, [
                    _createVNode("p", null, [
                      _createVNode("strong", _hoisted_80, _toDisplayString(_ctx.$t('estimation_title')), 1)
                    ]),
                    _createVNode("p", null, _toDisplayString(_ctx.state.data.details.title), 1)
                  ]),
                  _createVNode("div", _hoisted_81, [
                    _createVNode("p", null, [
                      _createVNode("strong", _hoisted_82, _toDisplayString(_ctx.$t('estimation_no')), 1)
                    ]),
                    _createVNode("p", null, "#" + _toDisplayString(_ctx.state.data.details.no), 1)
                  ]),
                  _createVNode("div", _hoisted_83, [
                    _createVNode("p", null, [
                      _createVNode("strong", _hoisted_84, _toDisplayString(_ctx.$t('date')), 1)
                    ]),
                    (_ctx.state.data.details.modifiedCreatedDate)
                      ? (_openBlock(), _createBlock("p", _hoisted_85, _toDisplayString(_ctx.state.data.details.modifiedCreatedDate), 1))
                      : (_openBlock(), _createBlock("p", _hoisted_86, _toDisplayString(_ctx.state.data.details.created_date), 1))
                  ])
                ]),
                _createVNode("div", _hoisted_87, [
                  (_ctx.state.data.details && _ctx.state.data.details.customers && _ctx.state.data.details.customers.length)
                    ? (_openBlock(), _createBlock("p", _hoisted_88, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('customer_details')) + ":", 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_89, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.details.customers, (customer, customerIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "col-md-4",
                        key: customerIndex
                      }, [
                        _createVNode("div", _hoisted_90, [
                          (customer.first_name || customer.last_name)
                            ? (_openBlock(), _createBlock("p", _hoisted_91, [
                                _createVNode("strong", _hoisted_92, _toDisplayString(_ctx.$t('name')) + ": ", 1),
                                _createTextVNode(_toDisplayString(customer.first_name) + " " + _toDisplayString(customer.last_name), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (customer.email)
                            ? (_openBlock(), _createBlock("p", _hoisted_93, [
                                _createVNode("strong", null, _toDisplayString(_ctx.$t('email')) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(customer.email), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (customer.phone)
                            ? (_openBlock(), _createBlock("p", _hoisted_94, [
                                _createVNode("strong", null, _toDisplayString(_ctx.$t('phone_no')) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(customer.phone), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _createVNode("div", _hoisted_95, [
                  _createVNode("table", _hoisted_96, [
                    _createVNode("thead", _hoisted_97, [
                      _createVNode("tr", _hoisted_98, [
                        _createVNode("th", _hoisted_99, _toDisplayString(_ctx.$t('item')), 1),
                        _createVNode("th", _hoisted_100, _toDisplayString(_ctx.$t('description')), 1),
                        _createVNode("th", _hoisted_101, _toDisplayString(_ctx.$t('unit')), 1),
                        _createVNode("th", _hoisted_102, _toDisplayString(_ctx.$t('qty')), 1),
                        _createVNode("th", _hoisted_103, _toDisplayString(_ctx.$t('cost')), 1),
                        _createVNode("th", _hoisted_104, _toDisplayString(_ctx.$t('sub_total')), 1),
                        _createVNode("th", _hoisted_105, _toDisplayString(_ctx.$t('markup')), 1),
                        _createVNode("th", _hoisted_106, _toDisplayString(_ctx.$t('allowance')), 1),
                        _createVNode("th", _hoisted_107, _toDisplayString(_ctx.$t('total')), 1)
                      ])
                    ]),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.details.phases, (mainItem, mainItemIndex) => {
                      return (_openBlock(), _createBlock("tbody", { key: mainItemIndex }, [
                        _createVNode("tr", null, [
                          _createVNode("td", _hoisted_108, [
                            _createVNode("p", _hoisted_109, [
                              _createVNode("strong", null, _toDisplayString(mainItem.name), 1)
                            ])
                          ])
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(mainItem.sub_items, (item, itemIndex) => {
                          return (_openBlock(), _createBlock("tr", { key: itemIndex }, [
                            _createVNode("td", null, [
                              _createVNode("div", _hoisted_110, [
                                _createVNode("p", null, _toDisplayString(item.name), 1)
                              ])
                            ]),
                            _createVNode("td", null, [
                              _createVNode("div", _hoisted_111, [
                                _createVNode("p", null, _toDisplayString(item.description), 1)
                              ])
                            ]),
                            _createVNode("td", null, [
                              _createVNode("p", null, _toDisplayString(item.unit ? item.unit.name : ''), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("p", null, _toDisplayString(item.quantity), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("p", null, _toDisplayString(item.cost), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("p", null, _toDisplayString(item.subTotal), 1)
                            ]),
                            _createVNode("td", null, [
                              (item.markup_type == 1)
                                ? (_openBlock(), _createBlock("p", _hoisted_112, _toDisplayString(item.markup) + " %", 1))
                                : (_openBlock(), _createBlock("p", _hoisted_113, _toDisplayString(item.markup), 1))
                            ]),
                            _createVNode("td", null, [
                              _createVNode("p", null, _toDisplayString(item.allowance), 1)
                            ]),
                            _createVNode("td", _hoisted_114, [
                              _createVNode("p", null, _toDisplayString(item.total), 1)
                            ])
                          ]))
                        }), 128))
                      ]))
                    }), 128))
                  ])
                ]),
                _hoisted_115,
                _createVNode("div", _hoisted_116, [
                  _createVNode("div", _hoisted_117, [
                    _createVNode("div", _hoisted_118, [
                      _createVNode("table", _hoisted_119, [
                        _createVNode("tbody", null, [
                          _createVNode("tr", null, [
                            _createVNode("th", _hoisted_120, _toDisplayString(_ctx.$t('total_amount')), 1),
                            _createVNode("th", _hoisted_121, _toDisplayString(_ctx.state.data.details.total), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _hoisted_122,
                (_ctx.state.data.details.declined_customers && _ctx.state.data.details.declined_customers.length > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_123, [
                      _createVNode("p", _hoisted_124, [
                        _createVNode("strong", _hoisted_125, _toDisplayString(_ctx.$t('declined_reason')) + ": ", 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.state.data.details.declined_customers[0].reason), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", null, [
                  _createVNode("div", null, [
                    ((_ctx.state.data.companyInfo && _ctx.state.data.companyInfo.acknowledgement && _ctx.state.data.companyInfo.legal_statement) || (_ctx.state.data.details && _ctx.state.data.details.acknowledgement && _ctx.state.data.details.legal_statement))
                      ? (_openBlock(), _createBlock("p", _hoisted_126, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('company_info')) + ":", 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  ((_ctx.state.data.companyInfo && _ctx.state.data.companyInfo.acknowledgement &&
                                        _ctx.state.data.companyInfo.legal_statement) || (_ctx.state.data.details && _ctx.state.data.details.acknowledgement &&
                                            _ctx.state.data.details.legal_statement)
                                    )
                    ? (_openBlock(), _createBlock("div", _hoisted_127, [
                        _createVNode("div", _hoisted_128, [
                          _createVNode("ul", _hoisted_129, [
                            _createVNode("li", _hoisted_130, [
                              _createVNode("button", _hoisted_131, _toDisplayString(_ctx.$t('acknowledgement')), 1)
                            ]),
                            _createVNode("li", _hoisted_132, [
                              _createVNode("button", _hoisted_133, _toDisplayString(_ctx.$t('legal_statement')), 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_134, [
                            _createVNode("div", _hoisted_135, [
                              _createVNode("div", {
                                innerHTML: _ctx.state.data.details?.acknowledgement || _ctx.state.data.companyInfo.acknowledgement
                              }, null, 8, ["innerHTML"])
                            ]),
                            _createVNode("div", _hoisted_136, [
                              _createVNode("div", {
                                innerHTML: _ctx.state.data.details?.legal_statement || _ctx.state.data.companyInfo.legal_statement
                              }, null, 8, ["innerHTML"])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.status != 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_137, [
                      _createVNode("p", _hoisted_138, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('note')), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.state.data.note), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.status != 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_139, [
                      _createVNode("div", _hoisted_140, [
                        _createVNode("p", _hoisted_141, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('signatures')) + ":", 1)
                        ])
                      ]),
                      _createVNode("div", _hoisted_142, [
                        (_ctx.state.data.details.signature)
                          ? (_openBlock(), _createBlock("div", _hoisted_143, [
                              _createVNode("div", _hoisted_144, [
                                _createVNode("img", {
                                  src: _ctx.state.data.details.signature,
                                  alt: ""
                                }, null, 8, ["src"])
                              ]),
                              _createVNode("p", null, [
                                _createVNode("strong", null, _toDisplayString(_ctx.$t('sender')) + ":", 1)
                              ]),
                              _createVNode("p", null, [
                                _createVNode("strong", null, _toDisplayString(_ctx.$t('date')) + ":", 1),
                                _createTextVNode(_toDisplayString(_ctx.state.data.details.signature_date), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.details.singed_customers, (customer, customerIndex) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "col-md-4",
                            key: customerIndex
                          }, [
                            _createVNode("div", _hoisted_145, [
                              _createVNode("img", {
                                src: customer.signature,
                                alt: ""
                              }, null, 8, ["src"])
                            ]),
                            _createVNode("p", null, [
                              _createVNode("strong", _hoisted_146, _toDisplayString(_ctx.$t('customer')) + ": ", 1),
                              _createTextVNode(_toDisplayString(customer.name
                                                ?
                                                customer.name : customer.email), 1)
                            ]),
                            _createVNode("p", null, [
                              _createVNode("strong", null, _toDisplayString(_ctx.$t('date')) + ":", 1),
                              _createTextVNode(" " + _toDisplayString(customer.signaute_date), 1)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_147, [
              (_ctx.state.data.details.pdf_link)
                ? (_openBlock(), _createBlock("a", {
                    key: 0,
                    href: "javascript:void(0)",
                    class: "btn default-btn mr-2",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.downoadPdf(_ctx.state.data.details.pdf_link)))
                  }, [
                    _hoisted_148,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('print')) + "t", 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.data.details.pdf_link)
                ? (_openBlock(), _createBlock("a", {
                    key: 1,
                    href: "javascript:void(0)",
                    class: "btn default-btn outline",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.downoadPdf(_ctx.state.data.details.pdf_link)))
                  }, [
                    _hoisted_149,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('download')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("button", _hoisted_150, _toDisplayString(_ctx.$t('close')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_151, [
      _createVNode("div", _hoisted_152, [
        _createVNode("div", _hoisted_153, [
          _createVNode("div", _hoisted_154, [
            _createVNode("div", _hoisted_155, [
              (_ctx.state.data.details.pdf_link)
                ? (_openBlock(), _createBlock("a", {
                    key: 0,
                    href: "javascript:void(0)",
                    class: "btn default-btn mr-2",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.downoadPdf(_ctx.state.data.details.pdf_link)))
                  }, [
                    _hoisted_156,
                    _hoisted_157
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.data.details.pdf_link)
                ? (_openBlock(), _createBlock("a", {
                    key: 1,
                    href: "javascript:void(0)",
                    class: "btn default-btn outline",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.downoadPdf(_ctx.state.data.details.pdf_link)))
                  }, [
                    _hoisted_158,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('download')), 1)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_159
            ]),
            _createVNode("div", _hoisted_160, [
              _createVNode("div", _hoisted_161, [
                _createVNode("div", _hoisted_162, [
                  _createVNode("div", _hoisted_163, [
                    _createVNode("div", _hoisted_164, [
                      (_ctx.state.data.details.logo || _ctx.state.data.companyInfo.logo)
                        ? (_openBlock(), _createBlock("img", {
                            key: 0,
                            src: _ctx.state.data.details.logo ? _ctx.state.data.details.logo : _ctx.state.data.companyInfo.logo,
                            alt: ""
                          }, null, 8, ["src"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_165, [
                      _createVNode("p", null, [
                        _createVNode("strong", _hoisted_166, _toDisplayString(_ctx.$t('address')), 1)
                      ]),
                      _createVNode("p", null, _toDisplayString(_ctx.state.data.companyInfo.company_address), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_167, [
                    _createVNode("p", null, [
                      _createVNode("span", _hoisted_168, _toDisplayString(_ctx.$t('email')) + ":", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.state.data.companyInfo.company_email), 1)
                    ]),
                    _createVNode("p", null, [
                      _createVNode("span", _hoisted_169, _toDisplayString(_ctx.$t('contact_no')) + ":", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.state.data.companyInfo.company_phone_number), 1)
                    ])
                  ])
                ]),
                _hoisted_170,
                _createVNode("div", _hoisted_171, [
                  _createVNode("div", _hoisted_172, [
                    _createVNode("p", null, [
                      _createVNode("strong", _hoisted_173, _toDisplayString(_ctx.$t('estimation_title')), 1)
                    ]),
                    _createVNode("p", null, _toDisplayString(_ctx.state.data.details.title), 1)
                  ]),
                  _createVNode("div", _hoisted_174, [
                    _createVNode("p", null, [
                      _createVNode("strong", _hoisted_175, _toDisplayString(_ctx.$t('estimation_no')), 1)
                    ]),
                    _createVNode("p", null, "#" + _toDisplayString(_ctx.state.data.details.no), 1)
                  ]),
                  _createVNode("div", _hoisted_176, [
                    _createVNode("p", null, [
                      _createVNode("strong", _hoisted_177, _toDisplayString(_ctx.$t('date')), 1)
                    ]),
                    (_ctx.state.data.details.modifiedCreatedDate)
                      ? (_openBlock(), _createBlock("p", _hoisted_178, _toDisplayString(_ctx.state.data.details.modifiedCreatedDate), 1))
                      : (_openBlock(), _createBlock("p", _hoisted_179, _toDisplayString(_ctx.state.data.details.created_date), 1))
                  ])
                ]),
                _createVNode("div", _hoisted_180, [
                  (_ctx.state.data.details && _ctx.state.data.details.customers && _ctx.state.data.details.customers.length)
                    ? (_openBlock(), _createBlock("p", _hoisted_181, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('customer_details')) + ":", 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_182, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.details.customers, (customer, customerIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "col-md-4",
                        key: customerIndex
                      }, [
                        _createVNode("div", _hoisted_183, [
                          (customer.first_name || customer.last_name)
                            ? (_openBlock(), _createBlock("p", _hoisted_184, [
                                _createVNode("strong", null, _toDisplayString(_ctx.$t('name')) + ": ", 1),
                                _createTextVNode(_toDisplayString(customer.first_name) + " " + _toDisplayString(customer.last_name), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (customer.email)
                            ? (_openBlock(), _createBlock("p", _hoisted_185, [
                                _createVNode("strong", null, _toDisplayString(_ctx.$t('email')) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(customer.email), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (customer.phone)
                            ? (_openBlock(), _createBlock("p", _hoisted_186, [
                                _createVNode("strong", null, _toDisplayString(_ctx.$t('phone_no')) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(customer.phone), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _createVNode("div", _hoisted_187, [
                  (_ctx.state.status == 0)
                    ? (_openBlock(), _createBlock("table", _hoisted_188, [
                        _createVNode("thead", _hoisted_189, [
                          _createVNode("tr", _hoisted_190, [
                            _createVNode("th", _hoisted_191, _toDisplayString(_ctx.$t('item')), 1),
                            _createVNode("th", _hoisted_192, _toDisplayString(_ctx.$t('description')), 1),
                            _createVNode("th", _hoisted_193, _toDisplayString(_ctx.$t('qty')), 1),
                            _createVNode("th", _hoisted_194, _toDisplayString(_ctx.$t('unit')), 1),
                            _createVNode("th", _hoisted_195, _toDisplayString(_ctx.$t('cost')), 1),
                            _createVNode("th", _hoisted_196, _toDisplayString(_ctx.$t('markup')), 1),
                            _createVNode("th", _hoisted_197, _toDisplayString(_ctx.$t('allowance')), 1),
                            _createVNode("th", _hoisted_198, _toDisplayString(_ctx.$t('total')), 1)
                          ])
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.details.phases, (mainItem, mainItemIndex) => {
                          return (_openBlock(), _createBlock("tbody", { key: mainItemIndex }, [
                            _createVNode("tr", null, [
                              _createVNode("td", _hoisted_199, [
                                _createVNode("p", _hoisted_200, [
                                  _createVNode("strong", null, _toDisplayString(mainItem.name), 1)
                                ])
                              ])
                            ]),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(mainItem.sub_items, (item, itemIndex) => {
                              return (_openBlock(), _createBlock("tr", { key: itemIndex }, [
                                _createVNode("td", null, [
                                  _createVNode("div", _hoisted_201, [
                                    _createVNode("p", null, _toDisplayString(item.name), 1)
                                  ])
                                ]),
                                _createVNode("td", null, [
                                  _createVNode("div", _hoisted_202, [
                                    _createVNode("p", null, _toDisplayString(item.description), 1)
                                  ])
                                ]),
                                _createVNode("td", null, [
                                  _createVNode("p", null, _toDisplayString(item.quantity), 1)
                                ]),
                                _createVNode("td", null, [
                                  _createVNode("p", null, _toDisplayString(item.unit ? item.unit.name : ''), 1)
                                ]),
                                _createVNode("td", null, [
                                  _createVNode("p", null, _toDisplayString(item.cost), 1)
                                ]),
                                _createVNode("td", null, [
                                  (item.markup_type == 1)
                                    ? (_openBlock(), _createBlock("p", _hoisted_203, _toDisplayString(item.markup) + " %", 1))
                                    : (_openBlock(), _createBlock("p", _hoisted_204, _toDisplayString(item.markup), 1))
                                ]),
                                _createVNode("td", null, [
                                  _createVNode("p", null, _toDisplayString(item.allowance), 1)
                                ]),
                                _createVNode("td", _hoisted_205, [
                                  _createVNode("p", null, _toDisplayString(item.total), 1)
                                ])
                              ]))
                            }), 128))
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createBlock("table", _hoisted_206, [
                        _createVNode("thead", _hoisted_207, [
                          _createVNode("tr", _hoisted_208, [
                            _createVNode("th", _hoisted_209, _toDisplayString(_ctx.$t('item')), 1),
                            (_ctx.state.fields.description == 1)
                              ? (_openBlock(), _createBlock("th", _hoisted_210, _toDisplayString(_ctx.$t('description')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.unit == 1)
                              ? (_openBlock(), _createBlock("th", _hoisted_211, _toDisplayString(_ctx.$t('unit')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.quantity == 1)
                              ? (_openBlock(), _createBlock("th", _hoisted_212, _toDisplayString(_ctx.$t('qty')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.cost == 1)
                              ? (_openBlock(), _createBlock("th", _hoisted_213, _toDisplayString(_ctx.$t('cost')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.subTotal == 1)
                              ? (_openBlock(), _createBlock("th", _hoisted_214, _toDisplayString(_ctx.$t('sub_total')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.markup == 1)
                              ? (_openBlock(), _createBlock("th", _hoisted_215, _toDisplayString(_ctx.$t('markup')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.allowance == 1)
                              ? (_openBlock(), _createBlock("th", _hoisted_216, _toDisplayString(_ctx.$t('allowance')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.total == 1)
                              ? (_openBlock(), _createBlock("th", _hoisted_217, _toDisplayString(_ctx.$t('total')), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.details.phases, (mainItem, mainItemIndex) => {
                          return (_openBlock(), _createBlock("tbody", { key: mainItemIndex }, [
                            _createVNode("tr", null, [
                              _createVNode("td", _hoisted_218, [
                                _createVNode("p", _hoisted_219, [
                                  _createVNode("strong", null, _toDisplayString(mainItem.name), 1)
                                ])
                              ])
                            ]),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(mainItem.sub_items, (item, itemIndex) => {
                              return (_openBlock(), _createBlock("tr", { key: itemIndex }, [
                                _createVNode("td", null, [
                                  _createVNode("div", _hoisted_220, [
                                    _createVNode("p", null, _toDisplayString(item.name), 1)
                                  ])
                                ]),
                                (_ctx.state.fields.description == 1)
                                  ? (_openBlock(), _createBlock("td", _hoisted_221, [
                                      _createVNode("div", _hoisted_222, [
                                        _createVNode("p", null, _toDisplayString(item.description), 1)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.state.fields.unit == 1)
                                  ? (_openBlock(), _createBlock("td", _hoisted_223, [
                                      _createVNode("p", null, _toDisplayString(item.unit ? item.unit.name : ''), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.state.fields.quantity == 1)
                                  ? (_openBlock(), _createBlock("td", _hoisted_224, [
                                      _createVNode("p", null, _toDisplayString(item.quantity), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.state.fields.cost == 1)
                                  ? (_openBlock(), _createBlock("td", _hoisted_225, [
                                      _createVNode("p", null, _toDisplayString(item.cost), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.state.fields.subTotal == 1)
                                  ? (_openBlock(), _createBlock("td", _hoisted_226, [
                                      _createVNode("p", null, _toDisplayString(item.subTotal), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.state.fields.markup == 1)
                                  ? (_openBlock(), _createBlock("td", _hoisted_227, [
                                      (item.markup_type == 1)
                                        ? (_openBlock(), _createBlock("p", _hoisted_228, _toDisplayString(item.markup) + " %", 1))
                                        : (_openBlock(), _createBlock("p", _hoisted_229, _toDisplayString(item.markup), 1))
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.state.fields.allowance == 1)
                                  ? (_openBlock(), _createBlock("td", _hoisted_230, [
                                      _createVNode("p", null, _toDisplayString(item.allowance), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.state.fields.total == 1)
                                  ? (_openBlock(), _createBlock("td", _hoisted_231, [
                                      _createVNode("p", null, _toDisplayString(item.total), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                        }), 128))
                      ]))
                ]),
                _hoisted_232,
                _createVNode("div", _hoisted_233, [
                  _createVNode("div", _hoisted_234, [
                    _createVNode("div", _hoisted_235, [
                      _createVNode("table", _hoisted_236, [
                        _createVNode("tbody", null, [
                          _createVNode("tr", null, [
                            _createVNode("th", _hoisted_237, _toDisplayString(_ctx.$t('total_amount')), 1),
                            _createVNode("th", _hoisted_238, _toDisplayString(_ctx.state.data.details.total), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _hoisted_239,
                (_ctx.state.data.details.declined_customers && _ctx.state.data.details.declined_customers.length > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_240, [
                      _createVNode("p", _hoisted_241, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('declined_reason')) + ": ", 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.state.data.details.declined_customers[0].reason), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                ((_ctx.state.data.companyInfo && _ctx.state.data.companyInfo.acknowledgement && _ctx.state.data.companyInfo.legal_statement) || (_ctx.state.data.details && _ctx.state.data.details.acknowledgement && _ctx.state.data.details.legal_statement))
                  ? (_openBlock(), _createBlock("p", _hoisted_242, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('company_info')) + ":", 1)
                    ]))
                  : _createCommentVNode("", true),
                ((_ctx.state.data.companyInfo && _ctx.state.data.companyInfo.acknowledgement && _ctx.state.data.companyInfo.legal_statement) || (_ctx.state.data.details && _ctx.state.data.details.acknowledgement && _ctx.state.data.details.legal_statement))
                  ? (_openBlock(), _createBlock("div", _hoisted_243, [
                      _createVNode("div", _hoisted_244, [
                        _createVNode("ul", {
                          class: "nav nav-tabs",
                          id: 'myTab-' + _ctx.modalIdentifier,
                          role: "tablist"
                        }, [
                          _createVNode("li", _hoisted_245, [
                            _createVNode("button", {
                              class: "nav-link active",
                              id: 'Contract-tab-' + _ctx.modalIdentifier,
                              "data-toggle": "tab",
                              "data-target": '#Contract-' + _ctx.modalIdentifier,
                              type: "button",
                              role: "tab",
                              "aria-controls": 'Contract-' + _ctx.modalIdentifier,
                              "aria-selected": "true"
                            }, _toDisplayString(_ctx.$t('acknowledgement')), 9, ["id", "data-target", "aria-controls"])
                          ]),
                          _createVNode("li", _hoisted_246, [
                            _createVNode("button", {
                              class: "nav-link",
                              id: 'Contract1-tab-' + _ctx.modalIdentifier,
                              "data-toggle": "tab",
                              "data-target": '#Contract1-' + _ctx.modalIdentifier,
                              type: "button",
                              role: "tab",
                              "aria-controls": 'Contract1-' + _ctx.modalIdentifier,
                              "aria-selected": "false"
                            }, _toDisplayString(_ctx.$t('legal_statement')), 9, ["id", "data-target", "aria-controls"])
                          ])
                        ], 8, ["id"]),
                        _createVNode("div", {
                          class: "tab-content",
                          id: 'myTabContent-' + _ctx.modalIdentifier
                        }, [
                          _createVNode("div", {
                            class: "tab-pane fade show active",
                            id: 'Contract-' + _ctx.modalIdentifier,
                            role: "tabpanel",
                            "aria-labelledby": 'Contract-tab-' + _ctx.modalIdentifier
                          }, [
                            _createVNode("div", {
                              innerHTML: _ctx.state.data.details?.acknowledgement || _ctx.state.data.companyInfo.acknowledgement
                            }, null, 8, ["innerHTML"])
                          ], 8, ["id", "aria-labelledby"]),
                          _createVNode("div", {
                            class: "tab-pane fade",
                            id: 'Contract1-' + _ctx.modalIdentifier,
                            role: "tabpanel",
                            "aria-labelledby": 'Contract1-tab-' + _ctx.modalIdentifier
                          }, [
                            _createVNode("div", {
                              innerHTML: _ctx.state.data.details?.legal_statement || _ctx.state.data.companyInfo.legal_statement
                            }, null, 8, ["innerHTML"])
                          ], 8, ["id", "aria-labelledby"])
                        ], 8, ["id"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_247, [
                  _createVNode("p", _hoisted_248, [
                    _createVNode("strong", null, _toDisplayString(_ctx.$t('note')), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.state.data.note), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_249, [
                  _createVNode("div", _hoisted_250, [
                    _createVNode("p", _hoisted_251, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('signatures')) + ":", 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_252, [
                    (_ctx.state.data.details.signature)
                      ? (_openBlock(), _createBlock("div", _hoisted_253, [
                          _createVNode("div", _hoisted_254, [
                            _createVNode("img", {
                              src: _ctx.state.data.details.signature,
                              alt: ""
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("p", null, [
                            _createVNode("strong", null, _toDisplayString(_ctx.$t('sender')) + ":", 1)
                          ]),
                          _createVNode("p", null, [
                            _createVNode("strong", null, _toDisplayString(_ctx.$t('date')) + ":", 1),
                            _createTextVNode(_toDisplayString(_ctx.state.data.details.signature_date), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.details.singed_customers, (customer, customerIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "col-md-4",
                        key: customerIndex
                      }, [
                        _createVNode("div", _hoisted_255, [
                          _createVNode("img", {
                            src: customer.signature,
                            alt: ""
                          }, null, 8, ["src"])
                        ]),
                        _createVNode("p", null, [
                          _createVNode("strong", _hoisted_256, _toDisplayString(_ctx.$t('customer')) + ": ", 1),
                          _createTextVNode(_toDisplayString(customer.name
                                                ?
                                                customer.name : customer.email), 1)
                        ]),
                        _createVNode("p", null, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('date')) + ":", 1),
                          _createTextVNode(" " + _toDisplayString(customer.signaute_date), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_257, [
              (_ctx.state.data.details.pdf_link)
                ? (_openBlock(), _createBlock("a", {
                    key: 0,
                    href: "javascript:void(0)",
                    class: "btn default-btn mr-2",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.downoadPdf(_ctx.state.data.details.pdf_link)))
                  }, [
                    _hoisted_258,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('print')), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.data.details.pdf_link)
                ? (_openBlock(), _createBlock("a", {
                    key: 1,
                    href: "javascript:void(0)",
                    class: "btn default-btn outline",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.downoadPdf(_ctx.state.data.details.pdf_link)))
                  }, [
                    _hoisted_259,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('download')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("button", _hoisted_260, _toDisplayString(_ctx.$t('close')), 1)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.ui.isActive.upgradeSubscription)
      ? (_openBlock(), _createBlock(_component_UpgradeSubscriptionModal, {
          key: 1,
          onCloseModal: _ctx.hideUpdateSubscriptionModal
        }, null, 8, ["onCloseModal"]))
      : _createCommentVNode("", true)
  ]))
}